/* The component responsible for rendering the actual sidesheets */
import React from 'react';
import useSidesheetV3 from 'Hooks/useSidesheetV3';
import { SIDESHEETS } from 'Components/utils/Sidesheet/SidesheetContextV3';
import NotificationSidesheetV3 from 'Components/sidesheets/NotificationSidesheet/NotificationSidesheetV3';
import RuleFilterSidesheetV3 from 'Components/sidesheets/RuleFilterSidesheet/RuleFilterSidesheetV3';
import EditUserSidesheetV3 from 'Components/sidesheets/EditUserSidesheet/EditUserSidesheetV3';
import UserInvitationSidesheetV3 from 'Components/sidesheets/UserInvitationSidesheet/UserInvitationSidesheetV3';
import SchemaViewerSidesheetV3 from 'Components/sidesheets/SchemaViewerSidesheet/SchemaViewerSidesheetV3';
import AiSummarySidesheetV3 from 'Components/sidesheets/AiSummarySidesheet/AiSummarySidesheetV3';
import SetLogStreamTypeSidesheetV3 from 'Components/sidesheets/SetLogStreamTypeSidesheet/SetLogStreamTypeSidesheetV3';
import ViewBucketDataSideSheetV3 from 'Components/sidesheets/ViewBucketDataSideSheet/ViewBucketDataSideSheetV3';

const SidesheetManagerV3: React.FC = () => {
  const { state: sidesheetState, hideSidesheet } = useSidesheetV3();

  let Component;
  switch (sidesheetState?.sidesheet) {
    case SIDESHEETS.EDIT_USER:
      Component = EditUserSidesheetV3;
      break;
    case SIDESHEETS.USER_INVITATION:
      Component = UserInvitationSidesheetV3;
      break;
    case SIDESHEETS.RULE_FILTER:
      Component = RuleFilterSidesheetV3;
      break;
    case SIDESHEETS.VIEW_BUCKET_DATA:
      Component = ViewBucketDataSideSheetV3;
      break;
    case SIDESHEETS.SET_LOG_STREAM_TYPE:
      Component = SetLogStreamTypeSidesheetV3;
      break;
    case SIDESHEETS.NOTIFICATION_CENTER:
      Component = NotificationSidesheetV3;
      break;
    case SIDESHEETS.SCHEMA_VIEWER:
      Component = SchemaViewerSidesheetV3;
      break;
    case SIDESHEETS.AI_SUMMARY:
      Component = AiSummarySidesheetV3;
      break;
    default:
      Component = null;
  }

  if (!Component) {
    return null;
  }

  return (
    <Component {...sidesheetState.props} open={sidesheetState.isVisible} onClose={hideSidesheet} />
  );
};

export default SidesheetManagerV3;
